import { useEffect, useRef, useState } from 'react';

export function AnimatedNumber({ value, format = 'number', duration = 400, prefix = '', suffix = '' }) {
  const [display, setDisplay] = useState(value);
  const prevRef = useRef(value);
  const frameRef = useRef(null);

  useEffect(() => {
    const from = prevRef.current;
    const to = value;
    prevRef.current = value;

    if (from === to) return;

    const start = performance.now();
    const diff = to - from;
    // Longer duration for big jumps
    const dur = Math.abs(diff) > 1000 ? duration * 2 : duration;

    function step(now) {
      const t = Math.min(1, (now - start) / dur);
      // Ease out cubic
      const eased = 1 - Math.pow(1 - t, 3);
      const current = from + diff * eased;
      setDisplay(current);
      if (t < 1) {
        frameRef.current = requestAnimationFrame(step);
      } else {
        setDisplay(to);
      }
    }

    frameRef.current = requestAnimationFrame(step);
    return () => {
      if (frameRef.current) cancelAnimationFrame(frameRef.current);
    };
  }, [value, duration]);

  let formatted;
  if (format === 'currency') {
    formatted = `${prefix}$${Math.round(display).toLocaleString()}${suffix}`;
  } else if (format === 'percent') {
    formatted = `${prefix}${Math.round(display)}%${suffix}`;
  } else {
    formatted = `${prefix}${Math.round(display).toLocaleString()}${suffix}`;
  }

  return formatted;
}
